<template>
    <div class="registered-form">
        <h2>注册维护大师通行证</h2>
        <!-- 输入框组合 -->
        <div class="form-group">
            <input
                type="text"
                class="form-input"
                ref="inp"
                v-model="form.passportName"
                placeholder="设置通行证账号"
                @focus="focusInput(1)"
                @blur="blurInput(1)"
            />
            <div class="registered-model" v-show="registeredModel">
                <span></span>
                <li>英文、数字、“-”、“_”均可，长度6-16个字符</li>
            </div>
            <div class="name-wrong" v-text="nameWrong"></div>
        </div>
        <div class="form-group">
            <input
                type="password"
                class="form-input"
                ref="inp2"
                v-model="form.passportPassword"
                maxlength="16"
                placeholder="设置你的登录密码"
                @focus="focusInput(2)"
                @blur="blurInput(2)"
            />
            <div class="registered-model2" v-show="registeredModel2">
                <span></span>
                <div>
                    <span></span>
                    <li>长度6-16个数字、大小写英文或符号任意两种以上组合</li>
                    <li>请再次输入你的密码</li>
                </div>
            </div>
        </div>
        <div class="form-group">
            <input
                type="password"
                class="form-input"
                ref="inp3"
                v-model="form.passport_passwords"
                maxlength="16"
                placeholder="请再次输入你的密码"
                @focus="focusInput(3)"
                @blur="blurInput(3)"
            />
            <div class="password-wrong" v-text="passwordWrong"></div>
        </div>
        <div class="form-group">
            <input
                type="text"
                class="form-input"
                ref="inp4"
                v-model="form.passportQq"
                placeholder="请输入你的QQ号"
                @focus="focusInput(4)"
                @blur="blurInput(4)"
            />
        </div>
        <div class="form-group">
            <input
                type="text"
                class="form-input"
                ref="inp5"
                v-model="form.personalName"
                placeholder="该怎么称呼你?"
                @focus="focusInput(5)"
                @blur="blurInput(5)"
            />
        </div>
        <div class="checkbox">
            <input
                type="checkbox"
                class="check"
                v-model="checked"
            />我已阅读并接受
            <router-link tag="a" target="_blank" :to="$PAGE_API.terms.path"
                >《软件注册条款》</router-link
            >
        </div>
        <div class="register-wrong" v-text="wrongText"></div>
        <div class="form-group">
            <button class="form-button" @click.prevent="handlSbmit">
                注册
            </button>
        </div>
    </div>
</template>
<script>
import { getRegister } from "@/requests/user";
import { mapState } from "vuex";
export default {
    computed: {
        ...mapState({
            phone: state => state.user.phone,
            smsCode: state => state.user.smsCode
        })
    },
    data() {
        return {
            showMsg: false,
            showCode: false,
            registeredModel: false,
            registeredModel2: false,
            msgText: "",
            id: "",
            wrongText: "",
            nameWrong: "",
            passwordWrong: "",
            showSuccess: false,
            checked: "",
            form: {
                passportName: "",
                passportPassword: "",
                passport_passwords: "",
                passportMobile: "",
                personalName: "",
                passportCode: "",
                passportQq: ""
            }
        };
    },
    methods: {
        //注册
        async handlSbmit() {
            this.wrongText = "";
            let nameRe = this.$validateCenter.passportNameWhds(
                this.form.passportName
            );
            if (nameRe.res == false) {
                this.wrongText = nameRe.msg;
                return false;
            }
            let reg = /^[a-zA-Z0-9_-]{1,}$/;
            let r = reg.test(this.form.passportName);
            if (r == false) {
                this.wrongText =
                    "通行证账号只能包括英文字符、数字、下划线、减号";
                return false;
            }
            let passwordRe = this.$validateCenter.passwordWhds(
                this.form.passportPassword
            );
            if (passwordRe.res == false) {
                this.wrongText = passwordRe.msg;
                return false;
            }
            if (this.form.passport_passwords != this.form.passportPassword) {
                this.wrongText = "两次密码不一致";
                return false;
            }
            if (this.form.passportQq == "") {
                this.wrongText =
                    "请提供你真实准确的QQ号，我们将根据你的QQ号拉你进产品群，这样可以更好的为你提供服务。";
                return false;
            }
            if (this.form.personalName == "") {
                this.wrongText = "称呼不能为空";
                return false;
            }
            if (this.checked == false) {
                this.wrongText = "如果要使用本公司服务，请阅读并接受注册条款";
                return false;
            }
            this.form.passportMobile = this.phone;
            this.form.passportCode = this.smsCode;
            let obj = {
                passportName: this.form.passportName,
                passportPassword: encodeURIComponent(
                    this.form.passportPassword
                ),
                passportMobile: this.form.passportMobile,
                passportCode: this.form.passportCode,
                passportQq: this.form.passportQq,
                personalName: this.form.personalName
            };
            let res = await getRegister(obj);
            if (res.code == 200) {
                this.$emit("showSuccessMsg", true);
            }
            if (res.code == "401") {
                this.wrongText = "注册超时并在5s倒计时后跳转到前一个注册页面";
                setTimeout(() => {
                    this.$router.push({
                        path: this.$PAGE_API.login.path + "?registerNo=1"
                    });
                }, 5000);
            } else {
                this.wrongText = res.msg;
            }
        },
        //边框聚焦变色
        focusInput(index) {
            if (index == 1) {
                this.nameWrong = "";
                this.registeredModel = true;
            } else if (index == 2) {
                this.passwordWrong = "";
                this.registeredModel2 = true;
            } else if (index == 3) {
                this.passwordWrong = "";
                this.registeredModel2 = true;
            }
        },
        //失去焦点恢复颜色
        blurInput(index) {
            if (index == 1) {
                this.registeredModel = false;
                if (this.form.passportName == "") {
                    this.nameWrong = "账号不能为空";
                }
            } else if (index == 2) {
                this.registeredModel2 = false;
            } else if (index == 3) {
                this.registeredModel2 = false;
                if (
                    this.form.passportPassword != this.form.passport_passwords
                ) {
                    this.passwordWrong = "两次密码不一致";
                }
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.registered-form {
    width: 320px;
    h2 {
        font-size: 30px;
        color: #373d41;
        font-weight: bold;
        line-height: 100px;
    }
    .form-group {
        width: 100%;
        padding: 10px 0;
        // 表单输入框
        .form-input {
            padding-left: 10px;
            width: 96.5%;
            height: 40px;
            font-weight: bold;
            border: 1px solid #dcdcdc;
            color: #000;
            outline: none;
            transition: all 0.7s;
        }
        .form-input:focus {
            border: 1px solid #00c2de;
        }
        // 表单按钮
        .form-button {
            margin-top: 30px;
            width: 100%;
            height: 40px;
            font-weight: bold;
            border: none;
            outline: none;
            color: #fff;
            background-color: #0099cc;
        }
        .form-button:hover {
            background-color: #28b5d6;
        }
        .form-button:active {
            background-color: #00ccff;
        }
        //验证码输入框
        .form-inputcode {
            padding-left: 10px;
            width: 69%;
            height: 40px;
            border: 1px solid #00c6de;
            color: #000;
            font-weight: bold;
            background-color: #ddf8fc;
        }
        // 验证码按钮
        .form-buttoncode {
            width: 29%;
            height: 42px;
            border: 1px solid #00c6de;
            background-color: #ddf8fc;
            border-left: none;
            color: #20c6e0;
            font-weight: bold;
        }
        // 手机号输入框
        .form-inputphone {
            padding-left: 10px;
            width: 78%;
            height: 40px;
            border: 1px solid #dcdcdc;
            color: #000;
            font-weight: bold;
        }
        // 手机号前缀
        .form-buttonphone {
            width: 20%;
            height: 42px;
            border: 1px solid #dcdcdc;
            border-right: none;
            font-weight: bold;
            color: #989aa0;
        }
        // 表单右侧提示
        .registered-model {
            position: absolute;
            transform: translate(325px, -41px);
            width: 293px;
            height: 40px;
            span {
                position: absolute;
                transform: translate(-5px, 15px);
                display: block;
                width: 1px;
                height: 1px;
                border-width: 7px;
                border-style: solid dashed dashed;
                border-color: transparent #fff transparent transparent;
                font-size: 0;
                line-height: 0;
            }
            li {
                margin-left: 10px;
                width: 280px;
                height: 100%;
                box-shadow: 0px 0px 15px 0px rgb(116, 114, 114);
                list-style-type: disc;
                line-height: 40px;
                color: #666;
            }
        }
        .registered-model2 {
            position: absolute;
            transform: translate(325px, -41px);
            width: 293px;
            height: 40px;
            span {
                position: absolute;
                transform: translate(-5px, 15px);
                display: block;
                width: 1px;
                height: 1px;
                border-width: 7px;
                border-style: solid dashed dashed;
                border-color: transparent #fff transparent transparent;
                font-size: 0;
                line-height: 0;
            }
            div {
                margin-left: 10px;
                width: 280px;
                box-shadow: 0px 0px 15px 0px rgb(116, 114, 114);
                span {
                    transform: translate(-15px, 75px);
                }
                li {
                    padding: 14px 0;
                    padding-left: 6px;
                    width: 274px;
                    height: 100%;
                    list-style-type: disc;
                    color: #666;
                    text-align: left;
                }
                li:nth-child(2) {
                    border-bottom: 1px solid #dcdcdc;
                }
            }
        }
    }
}
</style>
